<template>
  <div class="club-header">
    <template v-if="isLoading">
      <Loading/>
    </template>
    <template v-else-if="hasDbError">
      <Error 
        v-for="(error,key) in dbErrors"
        v-if="error" 
        :key="key"
        error="error"/>
    </template>
    <template v-else>
      <template v-if="club">
        <div class="text-xs-center ">
          <v-dialog 
            v-model="dialog2" 
            max-width="500px">
            <v-card>
              <v-card-text>
                <img 
                  v-if="logo"
                  :src="logo"
                  class="clubs-logo-big"
                  @click="dialog2=!dialog2">
              </v-card-text>
            </v-card>
          </v-dialog>
          <img 
            v-if="logo"
            :src="logo"
            class="clubs-logo-small"
            @click="dialog2=!dialog2">
          <h1>
            <a @click="goClub()">{{ club.club }}</a>
          </h1>
          <div class="text-xs-center grey--text" >
            <span @click="nativateSports">
              {{ $t(`sport.sports`) }}
            </span>
            <span> | </span>
            <span @click="nativateSport">
              {{ $t(`sport.types.${club.sport}.name`) }}
            </span>
          </div>
          <div v-if="club.externalLinkText && club.externalLinkUrl">
            <v-btn 
              color="primary"
              @click="goTo(club.externalLinkUrl)">
              {{ club.externalLinkText }}
            </v-btn>
          </div>
        </div>
      </template>
      <router-view/>
    </template>
  </div>
</template>
<script>
import _ from 'lodash'
import ClubsLib from '@/lib/data/clubs'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import DateHelper from '@/lib/DateHelper'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'

const debug = require('debug')('OD::ClubLayout')

export default {
  name: 'ClubLayout',
  components: { Loading, Error },
  mixins: [BaseMixin],
  props: {
    clubId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      club: {},
      dialog2: false,
      loadings: {
        club: true,
      },
      dbErrors: {
        club: null,
      },
    }
  },
  computed: {
    week() {
      return `${DateHelper.getWeekNumber()}`
    },
    year() {
      return `${DateHelper.getYearNumber()}`
    },
    logo() {
      if (this.club.logo && this.club.logo.value) {
        return this.club.logo.value
      }
    },
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
  },
  watch: {
    clubId() {
      this.bind()
    },
    currentUser() {
      this.bind()
    },
  },
  created() {
    debug('created')
  },
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  methods: {
    bind() {
      ClubsLib.bindItem(this, { clubId: this.clubId })
    },
    navigateTo(to) {
      debug('to', to)
      this.$router.push(to)
    },
    goClub() {
      this.navigateTo({
        name: 'WeekMatches',
        params: { clubId: this.clubId, year: this.year, week: this.week },
      })
    },
    goTo(url) {
      window.open(url, '_blank')
    },
    nativateSport() {
      this.navigateTo({
        name: 'SportClubs',
        params: { sport: this.club.sport },
      })
    },
    nativateSports() {
      this.navigateTo({ name: 'Sports' })
    },
  },
}
</script>
<style lang="scss">
.clubs-logo-small {
  width: 150px;
}
.clubs-logo-big {
  max-width: 100%;
}
</style>
